import React from 'react';
import VariantCard from './VariantCard';

const ResultsList = ({ enhancementResult, handleClear, handleSaveToJson }) => {
  return (
    <div className="results-screen" data-testid="resultsList-container">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-bold text-[#022B3A] dark:text-[#FFFFFF]">Enhanced Post Variants</h2>
        <div className="flex items-center gap-4">
          <button onClick={handleSaveToJson} className="bg-[var(--color-primary-accent)] text-white font-medium py-2 px-4 rounded-lg flex items-center gap-2 hover:bg-[var(--color-primary-accent-hover)] transition-colors" data-testid="resultsList-saveToJsonButton">
            <span className="material-icons-outlined text-base">download</span>
            Save to JSON
          </button>
          <button onClick={handleClear} className="bg-[var(--color-primary-accent)] text-white font-medium py-2 px-4 rounded-lg flex items-center gap-2 hover:bg-[var(--color-primary-accent-hover)] transition-colors" data-testid="resultsList-clearResultsButton">
            <span className="material-icons-outlined text-base">delete</span>
            Clear Results
          </button>
        </div>
      </div>
      <div className="space-y-6">
        {enhancementResult.variants && enhancementResult.variants.map((variant, index) => (
          <VariantCard key={index} variant={variant} index={index} />
        ))}
      </div>
    </div>
  );
};

export default ResultsList;
